import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../../cfet-core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-customer-verification-notrequired',
    templateUrl: './customer-no-verification-required.component.html',
    styleUrls: ['./customer-no-verification-required.component.scss'],
    standalone: false
})
export class CustomerNoVerificationRequiredComponent extends CfetBaseComponent implements OnInit {
  orgname: any;
  @Output() setNewSession = new EventEmitter<any>();
  @Output() showCancelModal = new EventEmitter<any>();

  constructor(private router: Router) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
    if (sessionStorage.getItem('orgName') && Object.keys(sessionStorage.getItem('orgName').length > 0)) {
      this.orgname = JSON.parse(sessionStorage.getItem('orgName')).orgname;
    }
  }

  continueToProfile(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PROFILE]);
      this.setNewSession.emit(true);
    }
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

}
